import Manual from './Manual.vue'

Manual.guid = '29bdebaccd9e452fac2be8963d3daba7'

export default {
  guid: '29bdebaccd9e452fac2be8963d3daba7',
  components: [
    Manual,
  ],
}
